import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { memo, useMemo, } from 'react';
import styleUtils from '../../styles/styleUtils';
import theme from '../../styles/theme';
import { carouselDotModifiers } from './constants';
const dotSize = 10;
const variationStyles = {
    [carouselDotModifiers.light]: {
        color: theme.colors.gray100,
    },
    [carouselDotModifiers.dark]: {
        color: theme.colors.gray400,
    },
};
// Change this to have onClick
const CarouselDot = ({ ariaLabel, isSelected, modifier, onClick, }) => {
    const carouselDotStyles = useMemo(() => (css `
        ${styleUtils.buttonReset}
        border-radius: 50%;
        cursor: pointer;
        height: ${styleUtils.rem(dotSize)};
        margin-right: ${theme.spacing.x3};
        width: ${styleUtils.rem(dotSize)};
        ${styleUtils.transition('background')}
        background-color: ${variationStyles[modifier].color};
        ${modifier === carouselDotModifiers.light && !isSelected && css `
          opacity: 50%;
        `}
        ${modifier === carouselDotModifiers.dark && !isSelected && css `
          background-color: ${theme.colors.gray700};
        `}

        &:last-of-type {
          margin-right: 0;
        }
      `), [
        isSelected,
        modifier,
    ]);
    return (_jsx("button", { "aria-label": ariaLabel, css: carouselDotStyles, onClick: onClick, type: "button" }));
};
const MemoizedCarouselDot = memo(CarouselDot);
export { MemoizedCarouselDot as CarouselDot };
